module.exports = __webpack_public_path__ + "img/scorpions.ddba21f7.png";